import React from "react";
import { LeagueRole, LeagueUser } from "../types/models";

interface LeagueMembershipContextType {
  /** The signed-in user's membership in the current league, once loaded. */
  membership: LeagueUser | undefined;
  role: LeagueRole | undefined;
  /** May add, edit, and delete league settings, seasons, teams, players, and games. */
  canManageLeague: boolean;
  /** May record game results through Quick Score and the Scoreboard. */
  canScoreGames: boolean;
  isLoading: boolean;
  error: Error | undefined;
  /** Reloads the membership, e.g. after the user changes their own role. */
  refreshMembership: () => void;
}

const LeagueMembershipContext =
  React.createContext<LeagueMembershipContextType>(null!);

function useLeagueMembership() {
  return React.useContext(LeagueMembershipContext);
}

export { LeagueMembershipContext, useLeagueMembership };
